import { ReactElement, useCallback, useEffect, useState } from 'react';
import { UIButton, UIExternalLinkButton, UISubNav, useUINav } from '@/ui';
import { BeaconsList, CreateBeaconModal } from '@/devices/components';
import { useCompanyContext } from '@/companies/providers';
import { BeaconsProvider, useBeacons } from '@/devices/providers';
import { useCompanyPermissions } from '@/companies/hooks';
import { usePagesTranslation } from '../hooks';
import { Navigate } from 'react-router';

export function BeaconsSettingsPage(): ReactElement {
    return (
        <BeaconsProvider>
            <BeaconsSettingsPage2 />
        </BeaconsProvider>
    );
}

function BeaconsSettingsPage2(): ReactElement {
    const { t } = usePagesTranslation();
    const { setParts } = useUINav();
    useEffect(() => {
        setParts([
            {
                text: t('shared.labels.settings')
            },
            { text: t('shared.labels.beacons') }
        ]);
    }, [setParts, t]);

    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const { company } = useCompanyContext();
    const { canViewBeacons } = useCompanyPermissions();
    const { availableTags } = useBeacons();

    const rightNode = useCallback(
        () => (
            <div style={{ display: 'flex', flexDirection: 'row', gap: 16 }}>
                <UIExternalLinkButton
                    href="https://www.safepointapp.com/hardware/location-beacon"
                    variant="default"
                    text={t('pages.beacons_settings.buy')}
                    leftIcon={'shopping-cart'}
                />

                <UIButton
                    variant="primary"
                    text={t('pages.beacons_settings.add')}
                    leftIcon={'plus-circle'}
                    onClick={() => setIsCreateModalOpen(true)}
                />
            </div>
        ),
        [t]
    );

    if (!canViewBeacons) {
        return <Navigate to="/" replace />;
    }

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    flex: 1,
                    flexDirection: 'column',
                    padding: 32,
                    gap: 24
                }}
            >
                <UISubNav
                    title={t('shared.labels.beacons')}
                    rightItems={rightNode()}
                />
                <BeaconsList />
            </div>
            <CreateBeaconModal
                availableTags={availableTags}
                companyId={company.id}
                isOpen={isCreateModalOpen}
                onClose={() => setIsCreateModalOpen(false)}
            />
        </>
    );
}
